import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';

interface HubSpotTokenStatus {
  has_token: boolean;
  is_full_integration_active: boolean;
}

/**
 * Hook to get HubSpot token status for AI Actions.
 * Returns has_token (token exists for AI Actions) and is_full_integration_active.
 *
 * The queryFn and staleTime live on the queryClient default registered for
 * `[QueryKey.integration.hubspotTokenStatus]` in `Config/api/queryClient.ts`.
 */
export const useHubSpotTokenStatus = () =>
  useQuery<HubSpotTokenStatus>({
    queryKey: [QueryKey.integration.hubspotTokenStatus],
  });
